import React, { ReactNode } from 'react';

// Components
import { Flex, Modal } from 'antd';
import CustomButton from './CustomButton';
import CustomTitle from './CustomTitle';
import CustomParagraph from './CustomParagraph';

interface CustomModalProps {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  modalTitle: string;
  modalText?: string;
  modalSize?: string | number;
  buttonText1?: string;
  buttonText2?: string;
  children?: ReactNode;
  isFormValid?: boolean;
  className?: string;
  centered?: boolean;
  onConfirmClick: () => void;
}

const CustomModal: React.FC<CustomModalProps> = ({
  modalOpen,
  setModalOpen,
  modalTitle,
  modalText,
  modalSize,
  buttonText1,
  buttonText2,
  children,
  isFormValid = false,
  className,
  centered = true,
  onConfirmClick,
}) => {
  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleConfirm = () => {
    onConfirmClick();
  };

  return (
    <Modal
      title=''
      centered={centered}
      open={modalOpen}
      onCancel={handleCancel}
      width={modalSize}
      className={className}
      footer={[
        <React.Fragment key='footer-actions'>
          <Flex gap='16px' justify='end'>
            {buttonText1 && (
              <CustomButton
                key='button1'
                onClick={handleCancel}
                text={buttonText1}
                bgColor='transparent'
                color='black'
                fontSize='16px'
                fontWeight='500'
                boxShadow='none'
                height='48px'
              />
            )}
            {buttonText2 && (
              <CustomButton
                key='button2'
                onClick={handleConfirm}
                text={buttonText2}
                bgColor='black'
                color='white'
                height='48px'
                width='100px'
                fontSize='16px'
                fontWeight='500'
                boxShadow='none'
                borderRadius='8px'
                isFormValid={isFormValid}
              />
            )}
          </Flex>
        </React.Fragment>,
      ]}
    >
      <CustomTitle
        className='ant-modal-heading'
        text={modalTitle}
        fontSize='28px'
        lineHeight='36px'
        fontWeight='700'
        marginBottom='4px'
      />

      <CustomParagraph
        text={modalText}
        fontSize='14px'
        fontWeight='400'
        lineHeight='20px'
        marginBottom='28px'
      />
      <main style={{ marginBottom: '28px' }}>{children}</main>
    </Modal>
  );
};

export default CustomModal;
